import Select from "./Select";
export { SingleSelect } from "./SingleSelect";
export type { SingleSelectProps } from "./SingleSelect";
export default Select;
